import React, {useState} from 'react';
import LineChart from '../../../component/Inc/LineChart';
import 'contents/assets/scss/page/mypage.scss';
import ImgProfile from 'contents/assets/img/@profile.png';
import PopChatting from '../_PopChatting';
function Teacher() {
  const [modalOpen, setModalOpen] = useState(false);
  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  const labels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const data = {
    lineChartlabels: labels,
    datasets: [
      {
        label: '',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false,
        legend: {
          display: true,
          labels: {
            boxWidth: 12,
            boxHeight: 12,
            color: '#222',
            Align: 'end'
          }
        }
      }
    ]
  };
  return (
    <main className="com_container com_teacher p_my_main">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_1">김교사507 교사</h2>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box box-1">
            <div className="detail_tit dot">수업정보</div>
            <div className="com_status_box">
              <div className="item big">
                <p className="tit">목표 수업 / 타임 수</p>
                <button className="com_btn gray xxs">수정</button>
                <p className="num">78 / 456</p>
              </div>
              <div className="item big">
                <p className="tit">진행 수업 / 타임 수</p>
                <p className="num">78 / 95</p>
              </div>
            </div>
            <div className="detail_tit dot">월간 평균 시수</div>
            <LineChart data={data} width={lineChartWidth} height={lineChartHeight} />
          </section>
          {/* 출석부 */}
          <section className="box sec_attendance">
            <div className="detail_tit dot">금일 출석부</div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="15.7%" />
                  <col width="22%" />
                  <col width="20%" />
                  <col width="14%" />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>학생명</th>
                    <th>수업일</th>
                    <th>출석선택</th>
                    <th>-P</th>
                    <th>댓글</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>김학생103</td>
                    <td className="td_date td_red">2023, 05, 10 14:30</td>
                    <td>
                      <select className="select">
                        <option value="조퇴">조퇴</option>
                      </select>
                    </td>
                    <td className="td_red">-12</td>
                    <td className="td_left">
                      <p className="memo">죄송합니다. 늦었습니다!@#!@#!@#</p>
                    </td>
                  </tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>김학생103</td>
                        <td className="td_date">2023, 05, 10 14:30</td>
                        <td>
                          <select className="select">
                            <option value="조퇴">조퇴</option>
                          </select>
                        </td>
                        <td>-12</td>
                        <td className="td_left">
                          <p className="memo">앗 죄송합니다. 늦었습니다!@#!@#!@#</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          {/* 수업 계획서 */}
          <section className="box">
            <div className="detail_tit dot">수업 계획서</div>
            <div className="notice_box orange">
              홍교사103님 앞으로 새로운 수업이 배정 되었습니다. <br />
              ‘수업계획서’ 를 작성해 주세요.
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="18%" />
                  <col width="34%" />
                  <col width="22%" />
                  <col width="26%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>학생명</th>
                    <th>첫 수업일</th>
                    <th>수업</th>
                    <th>수업 계획서</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>김학생103</td>
                    <td className="td_date">2023, 05, 10 14:30</td>
                    <td>첫수업</td>
                    <td>미작성</td>
                  </tr>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>김학생103</td>
                        <td className="td_date">2023, 05, 10 14:30</td>
                        <td>{idx + 1}달 차</td>
                        <td>2023, 05, 15</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          {/* 내 간단 정보 */}
          <section className="box">
            <div className="detail_tit dot ">
              내 간단 정보
              <button className="com_btn orange xs btn_plus">포인트 요청</button>
            </div>
            <div className="notice_box">
              <div className="info">
                <div className="name">
                  홍교사104
                  <span className="desc">
                    (<span>과탐</span>
                    <span className="dot">대면</span>
                    <span className="dot">과장 3호봉</span>)
                  </span>
                </div>
                <p className="date">계약일 : 2023.05.20</p>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="25%" />
                <col width="25%" />
                <col width="25%" />
                <col width="25%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>현 보유 포인트</th>
                  <td className="td_left td_point">1,224,000</td>
                  <th>총 포인트</th>
                  <td className="td_left td_point">1,224,000</td>
                </tr>
                <tr>
                  <th>직급 가점</th>
                  <td className="td_left td_point">65,456</td>
                  <th>필요 가점</th>
                  <td className="td_left td_point">4,300</td>
                </tr>
              </tbody>
            </table>
            <div className="com_status_box">
              <div className="item green">
                <p className="tit">직급평가 대상자</p>
                <p className="num">460</p>
              </div>
              <div className="item blue">
                <p className="tit">시수 인상 대상자</p>
                <p className="num">78</p>
              </div>
            </div>
          </section>
          {/* 수업 통계 */}
          <section className="box sec_mail">
            <div className="detail_tit dot ">수업 통계</div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col />
                  <col span="5" width="17%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>기간</th>
                    <th>타임수</th>
                    <th>손실률</th>
                    <th>취소</th>
                    <th>중단</th>
                    <th>종료</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{idx + 8}월</td>
                        <td>45</td>
                        <td>12</td>
                        <td>78</td>
                        <td>7</td>
                        <td>0</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          {/* 채팅 목록 */}
          <section className="box sec_chat">
            <div className="detail_tit dot ">채팅 목록</div>
            <ul className="chat_list">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                return (
                  <li onClick={() => setModalOpen(true)} className="item" key={idx}>
                    <p className="thumb">
                      <img src={ImgProfile} alt="profile" />
                    </p>
                    <div className="info_box">
                      <p className="name">홍길동103 (영어)</p>
                      <p className="desc">안녕하세요 12월에 입사한 이주영입니다. 미래를 만드는 이지와 함께 성장하고 싶습니다~~~~~</p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </section>
          {/* 수업 목록 */}
          <section className="box full">
            <div className="detail_tit dot ">수업 목록</div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="5%" />
                <col width="8%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
              </colgroup>
              <thead>
                <tr>
                  <th>학생명</th>
                  <th>수업시간</th>
                  <th>최근 수업 일</th>
                  <th>회차 / T</th>
                  <th>진행 회차</th>
                  <th>기수</th>
                  <th>메인교사 시수</th>
                  <th>서브교사 시수</th>
                  <th>1회 수업료</th>
                  <th>총 수업료</th>
                  <th>할인</th>
                  <th>실 수업료</th>
                  <th>총 입금 회차</th>
                  <th>총 입금액</th>
                  <th>미 입금액</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>김학생103</td>
                  <td>60분</td>
                  <td>2023.05.10 14:30</td>
                  <td>32/1T</td>
                  <td>12회</td>
                  <td>1기</td>
                  <td>40,000</td>
                  <td>30,000</td>
                  <td>
                    450,000 <br />
                    30,000
                  </td>
                  <td>407,000</td>
                  <td>형제할인 2%</td>
                  <td>458,000</td>
                  <td className="td_point">8.52</td>
                  <td className="td_point">645,000</td>
                  <td className="td_red">54,000</td>
                </tr>
                <tr>
                  <td>김학생103</td>
                  <td>60분</td>
                  <td>2023.05.10 14:30</td>
                  <td>32/1T</td>
                  <td>12회</td>
                  <td>1기</td>
                  <td>40,000</td>
                  <td>30,000</td>
                  <td>
                    450,000 <br />
                    30,000
                  </td>
                  <td>407,000</td>
                  <td>형제할인 2%</td>
                  <td>458,000</td>
                  <td className="td_point">8.52</td>
                  <td className="td_point">645,000</td>
                  <td className="td_red">54,000</td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>
      </div>
      <PopChatting open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default Teacher;
